export class FinancialUtils {
  static roundToCents(value: number): number {
    return FinancialUtils.roundToSecond(value);
  }

  static roundToSecond(value: number | null = 0): number {
    return Math.round((value || 0) * 100) / 100;
  }

  static toCents(value: null | number = 0): number {
    return Math.round((value || 0) * 100);
  }

  static fromCents(value: null | number = 0, precision?: null | number): number {
    if (!value) {
      return 0;
    }

    const result = value / 100;

    return precision ? parseFloat(result.toFixed(precision)) : result;
  }

  static toPercents(
    totalNumber: null | number = 0,
    partialNumber: null | number = 0,
    precision: number = 2,
  ): number {
    if (!totalNumber || !partialNumber) {
      return 0;
    }

    return parseFloat(((100 * partialNumber) / totalNumber).toFixed(precision));
  }

  static fromPercents(
    totalNumber: null | number = 0,
    percents: null | number = 0,
    precision: number = 2,
  ) {
    if (!totalNumber) {
      return 0;
    }
    return FU.round((totalNumber / 100) * (percents || 0), precision);
  }

  static toFloat(value: null | number | string = 0) {
    // eslint-disable-next-line no-param-reassign
    value = !isFinite(value as number) ? 0 : value;
    return parseFloat((value || 0).toString());
  }

  static toInt(value: null | number | string = 0) {
    // eslint-disable-next-line no-param-reassign
    value = !isFinite(value as number) ? 0 : value;
    return parseInt((value || 0).toString(), 10);
  }

  static abs(value: number) {
    return Math.abs(value);
  }

  static round(n: number, precision: number) {
    if (precision === 0) {
      return Math.round(n);
    }
    return Math.round(Number(String(n) + 'e' + precision)) / Math.pow(10, precision);
    /**
     * Following rounding method doesn't work correctly for 569.175
     * Math.round(569.175 * 100) / 100 = 569.17;
     *
     * Number.toFixed works incorrectly sometimes, for example:
     * 49.815.toFixed(2) returns 49.81
     * That's why next line is commented:
     * return parseFloat(n.toFixed(precision));
     */
  }

  static calcAbsoluteMargin(sell: number, cost: number, precision: number | null = null) {
    if (sell === 0) {
      return 0;
    }

    return sell - cost;
  }

  static calcMargin(
    sell: number | null,
    cost: number | null,
    precision: number | null = null,
  ) {
    // eslint-disable-next-line no-param-reassign
    sell = sell || 0;
    // eslint-disable-next-line no-param-reassign
    cost = cost || 0;

    if (cost === 0) {
      return 100;
    }

    if (sell === 0) {
      return 0;
    }

    const margin =
      (FinancialUtils.calcAbsoluteMargin(sell, cost) / FinancialUtils.abs(sell)) * 100 ||
      0;

    if (precision === null) {
      return margin;
    }

    return FinancialUtils.round(margin, precision);
  }

  static getDiscountAmount(amount: number, discount: number | null) {
    return self.fromPercents(amount, discount);
  }

  static applyDiscount(amount: number, discount: number | null) {
    if (!discount) {
      return amount;
    }
    return amount - self.getDiscountAmount(amount, discount);
  }
}
const self = FinancialUtils;
export const FU = FinancialUtils;
